module.exports = __webpack_public_path__ + "static/media/Hochzeitseinladung-4.f696134f.png";